import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../../core/services/auth.service';
import { FormControl, FormBuilder, Validators, FormGroup } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { first } from 'rxjs/operators';
import { PwaService } from '../../../core/services/pwa.service';

import * as AppConst from '../../../core/constants/app.const';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html'
})
export class LoginComponent implements OnInit {

  loginForm: FormGroup;
  submitted = false;
  loading = false;
  returnUrl: string;
  error = '';
  promptEvent: Event;
  version: string;

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private authService: AuthService,
    private router: Router,
    private pwaService: PwaService,
    private toastr: ToastrService,
  ) {
    if (this.authService.currentUserValue) {
      this.router.navigate(['/']);
    } else {
      this.promptEvent = this.pwaService.promptEvent;
    }
  }

  ngOnInit() {
    this.loginForm = this.formBuilder.group({
      username: ['', Validators.required],
      password: ['', Validators.required]
    });

    this.version = AppConst.VERSION;

    // get return url from route parameters or default to '/'
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
  }
  get f() { return this.loginForm.controls; }

  onAuthSubmit() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.loginForm.invalid) {
      return;
    }

    //SE COMPROBARA SI EL INVOICER ESTA EN MANTENIMIENTO.
    //Si es asi, se forzara un cierre de sesion antes de cargar un documento.
    this.authService.ObtenerEstadoMantenimiento().subscribe(enMantenimiento => {

      if (enMantenimiento == true) {

        this.toastr.info("El invoicer esta en mantenimiento. Intenta acceder mas tarde.");

      } else {

        this.loading = true;
        this.authService.Login(this.f.username.value, this.f.password.value)
          .pipe(first())
          .subscribe(
            data => {
              if (data) {
                this.router.navigate([this.returnUrl]);
              } else {
                this.loading = false;
                this.error = 'Datos de acceso incorrectos.';
              }
            },
            error => {
              this.error = error;
              this.loading = false;
            });
      }

    }, error => {
      console.log(error);
    });
  }

}
